import CommonIndicator from "components/common/CustomWorkOrderFieldIndicator";
import React from "react";
import styled from "styled-components";

const Indicator = styled(CommonIndicator)`
  position: relative;
  vertical-align: middle;
  margin-right: 6px;
  margin-left: 2px;
`;

export default function CustomWorkOrderField({ description, indicator, highlight }) {
  if (!description || !indicator || indicator === "blank") return null;

  return <Indicator color={indicator} highlight={highlight} title={description} />;
}
